import React, { useEffect } from 'react';
import Hero from '../sections/Hero';
import Methodology from '../sections/Methodology';
import FirstSession from '../sections/FirstSession';
import About from '../sections/About';
import ClinicalPilates from '../sections/ClinicalPilates';
import Doctors from '../sections/Doctors';
import FAQ from '../sections/FAQ';
import Gallery from '../sections/Gallery';
import Consult from '../sections/Consult';
import SEO from '../seo/SEO';
import { seoData } from '../../../data/seoData';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Initialize AOS animation library
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);
  
  // Handle appointment button click
  const handleAppointmentClick = () => {
    // Scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <SEO 
        title={seoData.home.title}
        description={seoData.home.description}
        keywords={seoData.home.keywords}
        canonical={seoData.home.canonical}
      />
      <Hero />
      <Methodology />
      <ClinicalPilates />
      <FirstSession />
      <About />
      <Doctors />
      <FAQ />
      <Gallery />
      <Consult onAppointmentClick={handleAppointmentClick} />
    </>
  );
};

export default HomePage; 